module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.b499d1b5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Light.ttf
// module id = 326
// module chunks = 3